module.exports = __webpack_public_path__ + "static/6305-woodrose-15-7952928d464af5fdbbbd1b6f0fbcc0e0.jpg";